(function(){
var elasticQueryContentType = {
    all: -1,
    file: 1,
    slide: 2,
    group: 4
};

var elasticQuerySortField = {
    _score: 0,
    name: 1,
    lastModDate: 2,
    recordDate: 3,
    avgRating: 4,
    importDate: 5
};

var elasticQuerySearchQueryType = {
    term: 0,
    wildcard: 1,
    match: 2,
    fuzzy: 3,
    matchPhrase: 4,
    queryString: 5
};

var elasticSearchQuery = {
    queryContentType: elasticQueryContentType.file,
    searchTerms: null,
    filters: null,
    exclusionFilters: null,
    options: null
};

var elasticSearchOperator = {
    or: 0,
    and: 1
};

var elasticQueryAnalyzer = {
    standard_english: 0,
    word_delimiter: 1,
    word_delimiter_with_stemming: 2,
    keyword: 3,
    keyword_lower: 4,
    standard: 5,
    synonyms: 6
};

var elasticSuggestionTypes = {
    all: -1,
    none: 0,
    term: 1,
    phrase: 2
};


var elasticSearchQueryValue = {
    // Highlights are returned for query values
    value: null,

    queryType: elasticQuerySearchQueryType.term,

    // You can affect the score for this value via boosting
    boost: null,

    // Fuzzy search options
    fuzziness: null,
    prefixLength: null,

    // match_phrase and query_string option
    slop: null,

    operator: elasticSearchOperator.or,

    analyzer: elasticQueryAnalyzer.standard_english,

    suggestionType: elasticSuggestionTypes.none
};

var elasticSearchAttribute ={
    name: null,
    values: null
};

var elasticSearchQuerySearchTerm = {
    name: [],
    title: [],
    description: [],
    text: [],
    notes: [],
    fileKeywords: [],
    slideKeywords: [],
    fileAttributes: {},
    slideAttributes: {}
};


var searchResults = {
    took: 0,
    maxScore: 0,
    timedOut: false,
    total: 0,
    hits: []
};

Librarian.ElasticSearch = new Class({
    Extends: Librarian.Request.JSON,
    Implements: Options,

    options: {
        method: "POST",
        loadComplete: null, /*(json, text)*/
        onFailure: Librarian.Utils.onFailure,
        beforeLoadComplete: null,
        elasticQueryContentType: elasticQueryContentType.file,
        elasticSearchQueryOptions: {
            // pagination
            from: 0,
            size: Librarian.search.maxResults,

            // include highlights for text hits
            highlights: true,

            preTag: "<strong>",
            postTag: "</strong>",

            // sorting
            // sortField: Librarian.elasticSearch.defaultSortType,
            // sortDescending: true,

            // attributes to return
            attributes: Librarian.elasticSearch.attributes,

            // accurate scoring
            dfsQueryThenFetch: true,
 
            // tuning best fields
            disMax: true,
			
			// include filter aggregations
            aggregates: Librarian.elasticSearch.aggregates,

            // include content statistics
            stats: Librarian.elasticSearch.stats
        }
    },

    searchOptions: null,

    initialize: function(options) {
        if ((typeof options == "undefined") || (options == null))
            options = {};

        this.setOptions(options);

        Librarian.ElasticSearch.loadSearchPreference();

        this.options.url = Librarian.path.getSearchUrl("esquery") + "&out=cjson&in=cjson";
        this.options.onSuccess = this.loadComplete;
        this.options.onException = options.onException;
        this.options.elasticSearchQueryOptions.sortField = Librarian.ElasticSearch.searchPreference.sortField || Librarian.ElasticSearch.sortField;
        this.options.elasticSearchQueryOptions.sortDescending = Librarian.ElasticSearch.searchPreference.sortDescending ||Librarian.ElasticSearch.sortDescending;
        this.options.elasticSearchQueryOptions.sortAttributeName = Librarian.ElasticSearch.searchPreference.sortAttributeName || Librarian.ElasticSearch.attributeSortName;

        this.searchOptions = Object.clone(elasticSearchQuery);
        this.searchOptions.options = Object.clone(this.options.elasticSearchQueryOptions);
        this.searchOptions.queryContentType = this.options.elasticQueryContentType;

        this.parent(this.options);
    },

    destroy: function() {
        this.cancel();
        this.clean();
        this.searchOptions = Object.clone(elasticSearchQuery);
    },

    clean: function() {
        this.response = null;

        this.xhr = null;

        this.xhr = new Browser.Request();
    },

    loadComplete: function (json) {
        if (typeof this.options.beforeLoadComplete == "function") {
            this.options.beforeLoadComplete(json);
        }

        if (typeof this.options.loadComplete == "function") {
            this.options.loadComplete.call(this, json);
        }  
    },

    // Return an empty set if there is an error
    onFailure: function() {
        if (typeof this.options.loadComplete == "function")
            this.options.loadComplete(Object.clone(searchResults));
    },

    search: function () {
        var searchOptions = Object.clone(this.searchOptions);
      
        if (instanceOf(searchOptions.searchTerms, Librarian.ElasticSearch.ElasticSearchQuerySearchTerms)) {
            searchOptions.searchTerms = searchOptions.searchTerms.members;
        }

        if (instanceOf(searchOptions.filters, Librarian.ElasticSearch.ElasticSearchQueryFilter)) {
            searchOptions.filters = searchOptions.filters.members;
        }

        if (instanceOf(searchOptions.exclusionFilters, Librarian.ElasticSearch.ElasticSearchQueryFilter)) {
            searchOptions.exclusionFilters = searchOptions.exclusionFilters.members;
        }

        searchOptions = JSON.stringify(searchOptions);

        if (typeof Base64 != "undefined")
            searchOptions = Base64.encode(searchOptions);

        this.options.data = searchOptions;
        this.send();

        if (this.options.afterRequestSend != null) {
            this.options.afterRequestSend(this);
        }
    },

    goToPage: function(pageNumber) {
        this.searchOptions.options.from = pageNumber * this.options.elasticSearchQueryOptions.size;

        this.search();
    }
})
.extend({
    queryAnalyzer: elasticQueryAnalyzer,
    searchResults: searchResults,
    searchQueryType: elasticQuerySearchQueryType,
    queryContentType: elasticQueryContentType,
    querySortField: elasticQuerySortField,
    searchOperator: elasticSearchOperator,
    suggestionTypes: elasticSuggestionTypes,
    sortField: Librarian.elasticSearch.defaultSortType,
    sortDescending: true,
    attributeSort: 7,
    searchPreference: null,
    loadSearchPreference: function () {
        if (Librarian.ElasticSearch.searchPreference == null) {
            var searchPreference = Cookie.read("searchPreferences");

            if (searchPreference) {
                Librarian.ElasticSearch.searchPreference = JSON.parse(searchPreference);
            }
            else {
                Librarian.ElasticSearch.searchPreference = {};
            }
        }
    },
    setSearchPreference: function (pref) {
        Librarian.ElasticSearch.searchPreference = Object.merge({}, Librarian.ElasticSearch.searchPreference, pref);

        Cookie.write("searchPreferences", JSON.stringify(Librarian.ElasticSearch.searchPreference));
    },
    getInstance: function () {
        var es = new Librarian.ElasticSearch({
            loadComplete: function (result) {
                Librarian.SearchResult.prepSearchPage(result, this.searchOptions);
            },
            beforeLoadComplete: function () {
                // Load the search tab
                Library.loadTabByName("search") || Library.loadTabByName("advancedsearch");
            }
        });

        return es;
    }
});


var ElasticSearchQuerySearchTerms = Librarian.ElasticSearch.ElasticSearchQuerySearchTerms = new Class({
    members: null,

    allSearchTerms: [],

    initialize: function() {
        this.members = Object.clone(elasticSearchQuerySearchTerm);
    },

    setValue: function(property, value, queryType, options) {
        if (this.members.hasOwnProperty(property)) {
            if (queryType === elasticQuerySearchQueryType.wildcard) {
                value = "*" + value + "*";
            }

            var esValue = ElasticSearchQuerySearchTerms.toEsValue(value, queryType, options);
            this.members[property].push(esValue);
            this.addSearchTerm(value, queryType);

            return esValue;
        }
    },

    setAttribute: function(property, name, value, queryType, options) {
        if (this.members.hasOwnProperty(property)) {
            var esValue = ElasticSearchQuerySearchTerms.toEsValue(value, queryType, options);
            this.members[property][name] = (this.members[property][name] || []).concat(esValue);
            this.addSearchTerm(value, queryType);

            return esValue;
        }
    },

    set: function (property, value, queryType, options) {
        var self = this;
        switch(property) {
            case "fileAttributes":
            case "slideAttributes":
                Object.each(value, function(item, key) {
                    self.setAttribute(property, key, item, queryType, options);
                });
                break;
            default:
                this.setValue(property, value, queryType, options);
        }
    },

    addSearchTerm: function(value, queryType) {
        var terms = ElasticSearchQuerySearchTerms.splitSearchTerms(value);
        var self = this;

        Array.each(terms, function (term) {
            if (queryType === elasticQuerySearchQueryType.wildcard) {
                term = term.replace(/\*/g, "");
            }

            if (!self.allSearchTerms.contains(term)) {
                self.allSearchTerms.push(term);
            }
        });
    }
})
.extend({
    searchQueryValue: elasticSearchQueryValue,

    splitSearchTerms: function(value) {
        return value.split(" ");
    },

    toEsValue: function(value, queryType, options) {
        options = options || {};
        var esValue = Object.merge({}, elasticSearchQueryValue, {
            value: value,
            queryType: queryType,
            boost: options.boost,
            fuzziness: options.fuzziness,
            prefixLength: options.prefixLength,
            slop: options.slop,
            operator: elasticSearchOperator[options.operator],
            analyzer: elasticQueryAnalyzer[options.analyzer],
            suggestionType: elasticSuggestionTypes[options.suggestionType]
        });

        return esValue;
    },

    getAllSearchTerms: function (query) {
        var allSearchTerms = [];

        Object.each(query, function(queryValue) {
            Array.each(queryValue, function (value) {
                var terms = ElasticSearchQuerySearchTerms.splitSearchTerms(value.value);

                Array.each(terms, function (term) {
                    if (!allSearchTerms.contains(term)) {
                        if (value.queryType === elasticQuerySearchQueryType.wildcard) {
                            term = term.replace(/\*/g, "");
                        }
                        allSearchTerms.push(term);
                    }
                });
            });

        });

        return allSearchTerms;
    }
});

var elasticSearchAutoComplete = {
    prefix: null,
    size: 5,
    skipDuplicates: true,
    fuzziness: 1,
    field: Librarian.elasticSearch.searchFieldType,
    contentTypes: elasticQueryContentType.file
}

var elasticSearchAutoCompleteResults = {
    took: 0,
    timedOut: false,
    prefix: null,
    suggestions: []
    }


Librarian.ElasticSearch.Suggest = new Class({
    Extends: Librarian.Request.JSON,
    Implements: Options,

    options: {
        method: "POST",
        loadComplete: null, /*(json, text)*/
        onFailure: Librarian.Utils.onFailure
    },

    autoCompleteOptions: null,

    initialize: function (options) {
        if ((typeof options == "undefined") || (options == null))
            options = {};

        this.setOptions(options);

        this.options.url = Librarian.path.getSearchUrl("essugg") + "&out=cjson&in=cjson";
        this.options.onSuccess = this.loadComplete;
        this.options.onException = options.onException;


        this.parent(this.options);
    },

    destroy: function () {
        this.cancel();
        this.clean();
    },

    clean: function () {
        this.response = null;

        this.xhr = null;

        this.xhr = new Browser.Request();
    },

    loadComplete: function (json) {
        if (typeof this.options.loadComplete == "function")
            this.options.loadComplete(json);
    },

    // Return an empty set if there is an error
    onFailure: function () {
        if (typeof this.options.loadComplete == "function")
            this.options.loadComplete(Object.clone(elasticSearchAutoCompleteResults));
    },

    suggest: function (text, options) {
        var body = Object.clone(options) || {};
        body.text = text.toLowerCase();

        if (body.suggestionType != null) {
            body.suggestionType = Librarian.ElasticSearch.suggestionTypes[body.suggestionType];
        }
 
        var suggestOptions = JSON.stringify(body);

        if (typeof Base64 != "undefined")
            suggestOptions = Base64.encode(suggestOptions);

        this.options.data = suggestOptions;
        this.send();
    }
});

Librarian.ElasticSearch.Autocomplete = new Class({
    Extends: Librarian.Request.JSON,
    Implements: Options,

    options: {
        method: "POST",
        loadComplete: null, /*(json, text)*/
        onFailure: Librarian.Utils.onFailure,
        elasticSearchAutoComplete: Object.clone(elasticSearchAutoComplete)
    },

    autoCompleteOptions: null,

    initialize: function (options) {
        if ((typeof options == "undefined") || (options == null))
            options = {};

        this.setOptions(options);

        this.options.url = Librarian.path.getSearchUrl("esauto") + "&out=cjson&in=cjson";
        this.options.onSuccess = this.loadComplete;
        this.options.onException = options.onException;

        this.autoCompleteOptions = Object.clone(this.options.elasticSearchAutoComplete);

        this.parent(this.options);
    },

    destroy: function () {
        this.cancel();
        this.clean();
        this.autoCompleteOptions = Object.clone(this.options.elasticSearchAutoComplete);
    },

    clean: function () {
        this.response = null;

        this.xhr = null;

        this.xhr = new Browser.Request();
    },

    loadComplete: function (json) {
        if (typeof this.options.loadComplete == "function")
            this.options.loadComplete(json);
    },

    // Return an empty set if there is an error
    onFailure: function () {
        if (typeof this.options.loadComplete == "function")
            this.options.loadComplete(Object.clone(elasticSearchAutoCompleteResults));
    },

    search: function () {
        var autoCompleteOptions = JSON.stringify(this.autoCompleteOptions);

        if (typeof Base64 != "undefined")
            autoCompleteOptions = Base64.encode(autoCompleteOptions);

        this.options.data = autoCompleteOptions;
        this.send();
    }
})
.extend({
    searchAutoCompleteResults: elasticSearchAutoCompleteResults,
    createAutoCompleteElement: function (searchEl) {
        searchEl.set("type", "search");
        searchEl.addClass("elastic-search-box");
        searchEl.set("autocomplete", "off");

        var searchContEl = searchEl.getParent();
        searchContEl.addClass("autocomplete").set("tabindex", -1);

        var autoCompleteId = "search-autocomplete-items-" + (new Date()).getTime();
        var autoCompleteEl = new Element("div", {
            "class": "autocomplete-items",
            "id": autoCompleteId
        });

        searchEl.grab(autoCompleteEl, "after");

        searchEl.addEvent("focus", function() {
            autoCompleteEl.show();
            Library.searchAutoComplete(searchEl);
        });

        searchContEl.addEvent("focusout", function(e) {
            var focusedEl = e.event.relatedTarget;
            var hasFocus = searchContEl.hasChild(focusedEl) || focusedEl == searchContEl;

            if (!hasFocus)
                autoCompleteEl.hide();
        });

        var setItemActive = function(direction) {
            var activeEl = autoCompleteEl.getElement(".autocomplete-active");
            var nextActiveEl;

            if (activeEl) {
                if (direction === "up") {
                    nextActiveEl = activeEl.getPrevious();
                } else {
                    nextActiveEl = activeEl.getNext();
                }

            } else {
                nextActiveEl = autoCompleteEl.getFirst();
            }

            if (nextActiveEl != null) {
                autoCompleteEl.getChildren().removeClass("autocomplete-active");
                nextActiveEl.addClass("autocomplete-active");
            }
        }

        searchEl.addEvent("keyup", function (e) {
            if (e.key == "enter") {
                var activeEl = autoCompleteEl.getElement(".autocomplete-active");

                if (activeEl != null) {
                    e.stop();
                    e.event.stopImmediatePropagation();
                    activeEl.fireEvent("click");
                }

                autoCompleteEl.hide();
                searchEl.blur();
            }
            else if (e.key === "up") {
                setItemActive("up");
            }
            else if (e.key === "down") {
                setItemActive("down");
            }
        });

        /*

        searchEl.addEvent("click", function (e) {
            e.stop();
        });*/

        searchEl.addEvent("input", function () {
            autoCompleteEl.show();
            Library.searchAutoComplete(searchEl);
        });

    },
    getInstance: function(searchEl) {
        if (Librarian.elasticSearch.autoComplete) {
            var autoComplete = new Librarian.ElasticSearch.Autocomplete({
                loadComplete: function(results) {
                    results = results || Librarian.ElasticSearch.Autocomplete.searchAutoCompleteResults;
                    var dataListEl = searchEl.getNext(".autocomplete-items");

                    if (dataListEl) {
                        dataListEl.empty();

                        Array.each(results.suggestions,
                            function(suggestion) {
                                if (Librarian.elasticSearch.searchFieldType == 1)
                                    var name = suggestion.title;
                                else 
                                     var name = suggestion.name;;

                                var optionEl = new Element("div",
                                {
                                    "text": name,
                                    "class": "autocomplete-item"
                                });

                                optionEl.addEvent("click",
                                    function(e) {
                                        var es = Librarian.ElasticSearch.getInstance(),
                                            libraryFilters = Librarian.elasticSearch.filters;

                                        var filters = new Librarian.ElasticSearch.ElasticSearchQueryFilter();
                                        filters.setContent(suggestion.contentId, suggestion.contentType);

                                        if (libraryFilters != {}) {
                                            for (var key in libraryFilters) {
                                                var property = key.toString();
                                                if (typeOf(libraryFilters[key]) == "object") {
                                                    var attributes = libraryFilters[key];
                                                    for (var attribKey in attributes) {
                                                        filters
                                                            .setAttribute(property,
                                                                attribKey.toString(),
                                                                attributes[attribKey]);
                                                    }
                                                } else {
                                                    filters.setAttribute(property, key.toString(), libraryFilters[key]);
                                                }
                                            }
                                        }

                                        es.searchOptions.filters = filters;

                                        Librarian.search.lastQuery = es.searchOptions;
                                        es.search();

                                        dataListEl.empty();

                                        var searchInputEl = searchEl;
                                        if (searchInputEl) {
                                            searchInputEl.set("value", suggestion.title);
                                        }
                                    });

                                dataListEl.grab(optionEl);
                            });
                    }
                }
            });
        }

        return autoComplete;
    }
});

var elasticSearchQueryFilter = {
    lastModDate: null,
    recordDate: null,
    categoryIds: null,
    categoryPaths: null,
    parentContentType: null,
    fileTypes: null,
    fileSubTypes: null,
    fileExtensions: null,
    fileKeywords: null,
    fileAttributes: null,
    slideKeywords: null,
    slideAttributes: null,
    content: null
    //parentContentType: elasticQueryContentType.file TODO fix search on slides not working and add this back
};

var searchDate = {
    minDate: null,
    maxDate: null
};

var esContent = {
    contentId: -1,
    contentType: Librarian.contentType.file
}

var esAttribute = {
    name: null,
    values: null
}

Librarian.ElasticSearch.ElasticSearchQueryFilter = new Class({
    members: null,

    initialize: function (data) {
        this.members = Object.clone(elasticSearchQueryFilter);
        var self = this;

        Object.each(data, function(value, key) {
            self.set(key, value);
        });
    },

    setDate: function(property, minDate, maxDate) {
        if (this.members.hasOwnProperty(property)) {
            var dateValue = Object.clone(searchDate);

            if ((minDate || "").trim().length !== 0) {
                dateValue.minDate = Librarian.Utils.extractDateFromString(minDate);
            }

            if ((maxDate || "").trim().length !== 0) {
                dateValue.maxDate = Librarian.Utils.extractDateFromString(maxDate);
            }

            this.members[property] = dateValue;

            return dateValue;
        }
    },

    setContent: function(contentId, contentType) {
        var content = Object.clone(esContent);
        content.contentId = contentId;
        content.contentType = contentType;

        this.members["content"] = content;

        return content;
    },


    setAttribute: function (property, name, value) {
        if (this.members.hasOwnProperty(property)) {
            var attribute = Object.clone(esAttribute);
            attribute.name = name;

            if (Librarian.elasticSearch.filterOperator != null) {
                attribute.operator = Librarian.elasticSearch.filterOperator;
            }

            if (value.hasOwnProperty("minDate") || value.hasOwnProperty("maxDate")) {
                if (value.minDate != null && value.minDate != "") {
                    attribute.minValue = new Date(value.minDate).format('%Y-%m-%dT%H:%M:%S');
                }
                if (value.maxDate != null && value.maxDate != "") {
                    attribute.maxValue = new Date(value.maxDate).format('%Y-%m-%dT23:59:59');
                }   
            }
            else if (value.isCategorized) {
                attribute.isCategorized = value.isCategorized;
                attribute.catIds = value.catIds;
            }
            else {
                attribute.values = Array.from(value);
            }

            this.members[property] = (this.members[property] || []).concat(attribute);

            return attribute;
        }
    },

    attributeExists: function (property, name) {
        var currentVal = this.members[property];

        if (currentVal != null) {
            return this.members[property].some(function(attribute) {
                return attribute.name == name;
            });
        }

        return false;
    },

    setValue: function(property, value, merge) {
        if (this.members.hasOwnProperty(property)) {
            value = Array.from(value);

            if (merge) {
                this.members[property] = (this.members[property] || []).concat(value);
            }
            else {
                this.members[property] = value;
            }
        }
    },

    setCategoryPaths: function() {

    },

    set: function (property, value, preventOverride) {
        var self = this;
        var currentVal = this.members[property];

        if (preventOverride && currentVal != null && !["fileAttributes", "slideAttributes"].contains(property)) {
            return;
        }

        switch(property) {
            case "lastModDate":
            case "recordDate":
                this.setDate(property, value.minDate, value.maxDate);
                break;
            case  "content":
                this.setContent(property, value.contentId, value.contentType);
                break;
            case "fileAttributes":
            case "slideAttributes":
                Object.each(value, function (item, key) {
                    if (!preventOverride || !self.attributeExists(property, key)) {
                        self.setAttribute(property, key, item);
                    }
                });
                break;
            case "parentContentType":
                this.members[property] = value;
                break;
            default:
                this.setValue(property, value);
                break;
        }
    }

});
})();